import React, { useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faSync,
	faTimesCircle,
	faCheck,
} from "@fortawesome/free-solid-svg-icons"
import * as Addons from "../../utilities/Addons"
import {
	postDepPaid,
	postDepPaidReset,
} from "../../store/actions/atelierExtrasActions"
import CustomModal from "../basics/interface/CustomModal"
import Loader from "../basics/Loader"
import { generalStyles } from "../styles/styles"
import { COLORS } from "../../utilities/Constants"
import { filterEmployesActifs } from "../../utilities/employes"
import { filtrerMoyensPaiement } from "../../hooks/moyenPaiement"

// Version V2 (CustomModal) de AtelierRestiDepModal — encaissement du dépannage
// lié non payé avant restitution. Props : appels, closeModal, closeModal2,
// dispatch, info, moyenPaiements, depanneurs, restiDep, dep.
const AtelierRestiDepModalV2 = ({
	appels,
	closeModal,
	closeModal2,
	dispatch,
	moyenPaiements,
	depanneurs,
	restiDep,
	dep,
}) => {
	const [resti, setResti] = useState({
		reprisPar: "",
		moyenPaiement: 0,
		quittanceRecuPar: "",
		adresse: "",
		caissier: 0,
		transTarif: "",
		restiTarif: "",
	})
	const { fetchDepPaid, postDepPaid: postStatus, depPaid } = restiDep

	// Le pré-remplissage moyen/quittance depuis l'appel legacy est supprimé
	// (référentiel Appel retiré) : les champs se saisissent à la main.

	const update = (field, value) =>
		setResti((r) => ({
			...r,
			[field]: ["caissier", "moyenPaiement"].includes(field)
				? parseInt(value)
				: value,
		}))

	const doResti = () =>
		dispatch(postDepPaid({ case: "0", id: dep, ...resti }))

	const closeInner = () => {
		dispatch(postDepPaidReset())
		closeModal()
	}

	const centered = {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		gap: 10,
		padding: "12px 0",
	}

	if (fetchDepPaid.loading) {
		return (
			<CustomModal
				title={"Vérification du dépannage"}
				showFooter={false}
				showCloseButton={false}
				onClose={closeInner}
			>
				<Loader size={28} padding={24} />
			</CustomModal>
		)
	}
	if (fetchDepPaid.error) {
		return (
			<CustomModal
				title={"Erreur"}
				onClose={closeInner}
				showCloseButton={false}
				buttons={[
					{ title: "Ok", styleName: "primary", onClick: closeInner },
				]}
			>
				<div style={centered}>
					<FontAwesomeIcon
						icon={faTimesCircle}
						size="2x"
						style={{ color: COLORS.danger }}
					/>
					<div>{`${fetchDepPaid.error.status}`}</div>
					<div>{`${fetchDepPaid.error.msg}`}</div>
					<div>Ce rapport d'erreur a été sauvegardé</div>
				</div>
			</CustomModal>
		)
	}
	if (postStatus.saving) {
		return (
			<CustomModal
				title={"Sauvegarde..."}
				showFooter={false}
				showCloseButton={false}
				onClose={closeInner}
			>
				<div style={centered}>
					<FontAwesomeIcon icon={faSync} size="2x" spin />
				</div>
			</CustomModal>
		)
	}
	if (postStatus.saved) {
		return (
			<CustomModal
				title={"Sauvegarde terminée"}
				onClose={closeModal2}
				showCloseButton={false}
				buttons={[
					{
						title: "Fermer",
						styleName: "primary",
						onClick: closeModal2,
					},
				]}
			>
				<div style={centered}>
					<FontAwesomeIcon
						icon={faCheck}
						size="2x"
						style={{ color: COLORS.success }}
					/>
				</div>
			</CustomModal>
		)
	}
	if (postStatus.error) {
		return (
			<CustomModal
				title={"Erreur"}
				onClose={closeInner}
				showCloseButton={false}
				buttons={[
					{ title: "Ok", styleName: "primary", onClick: closeInner },
				]}
			>
				<div style={centered}>
					<FontAwesomeIcon
						icon={faTimesCircle}
						size="2x"
						style={{ color: COLORS.danger }}
					/>
					<div>{`${postStatus.error.status}`}</div>
					<div>{`${postStatus.error.msg}`}</div>
					<div>Ce rapport d'erreur a été sauvegardé</div>
				</div>
			</CustomModal>
		)
	}

	const disabled =
		resti.caissier === 0 ||
		resti.adresse === "" ||
		resti.moyenPaiement === 0 ||
		resti.quittanceRecuPar === "" ||
		resti.transTarif === ""

	return (
		<CustomModal
			title={"Dépannage non-payé"}
			onClose={closeInner}
			showCloseButton={false}
			buttons={[
				{
					title: "Annuler",
					styleName: "secondary",
					onClick: closeInner,
				},
				{
					title: "Ok",
					styleName: "primary",
					onClick: doResti,
					disabled,
				},
			]}
		>
			<div style={generalStyles.fieldRow}>
				<label style={generalStyles.label}>Moy. paiement</label>
				<select
					style={generalStyles.select}
					value={resti.moyenPaiement}
					onChange={(e) => update("moyenPaiement", e.target.value)}
				>
					<option value={0}>-</option>
					{filtrerMoyensPaiement(moyenPaiements, {
						module: "dep",
						valeurCourante: resti.moyenPaiement,
					}).map((mdp) => (
						<option key={`mdp${mdp.id}`} value={mdp.id}>
							{mdp.nom}
						</option>
					))}
				</select>
			</div>
			<div style={generalStyles.fieldRow}>
				<label style={generalStyles.label}>Payé par</label>
				<input
					type="text"
					style={generalStyles.input}
					value={resti.quittanceRecuPar}
					onChange={(e) => update("quittanceRecuPar", e.target.value)}
				/>
			</div>
			<div style={generalStyles.fieldRow}>
				<label style={generalStyles.label}>Adresse</label>
				<input
					type="text"
					style={generalStyles.input}
					value={resti.adresse}
					onChange={(e) => update("adresse", e.target.value)}
				/>
			</div>
			<div style={generalStyles.fieldRow}>
				<label style={generalStyles.label}>Caissier</label>
				<select
					style={generalStyles.select}
					value={resti.caissier}
					onChange={(e) => update("caissier", e.target.value)}
				>
					<option value={0}>-</option>
					{filterEmployesActifs(depanneurs, resti.caissier).map(
						(d) => (
							<option key={`caissier${d.id}`} value={d.id}>
								{d.nom}
							</option>
						),
					)}
				</select>
			</div>
			<div style={generalStyles.fieldRow}>
				<label style={generalStyles.label}>Reste à payer</label>
				<input
					type="text"
					style={generalStyles.input}
					value={resti.transTarif}
					placeholder={depPaid && depPaid.delta}
					onChange={(e) => update("transTarif", e.target.value)}
					onKeyDown={(e) => Addons.typeNumber(e)}
				/>
			</div>
		</CustomModal>
	)
}

export default AtelierRestiDepModalV2
